
























































































import { toFixed, formatCurrency } from "@core/filters";
import storeInstance from "@/store";
import { computed, onMounted, onUnmounted, Ref, ref } from "@vue/composition-api";
import { storeToRefs } from "pinia";
import { useRequisiteStore } from "@/stores/webmaster/finance/modal/requisiteStore";
import { usePayoutStore } from "@/stores/webmaster/finance/modal/payoutStore";
import { Requisite } from "@core/store/types/webmaster/finances/modal/financeRequisites";
import { actionWithToast } from "@/helpers/actionWithToast";
import { defineExpose } from "@vue/runtime-dom";
import { RequisiteStatusEnum } from "@core/store/types/webmaster/finances/modal/enum/requisiteStatusEnum";
import { useWait } from "@/stores/common/waitStore";
import { DialogProgrammatic, ToastProgrammatic } from "buefy";
import i18nPlugin from "@core/plugins/i18n";
import FinancePaymentList from "@/components/Webmaster/Finance/modal/FinancePaymentModal/FinancePaymentList.vue";
import CanCopy from "@/components/Common/Tooltip/CanCopy.vue";
import { Money } from "@core/store/types/common";
import router from "@/router";
import i18n from "@core/plugins/i18n";
import { BNoticeConfig } from "buefy/types/components";
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const payoutStore = usePayoutStore();
  const {
    input
  } = storeToRefs(payoutStore);
  const requisiteStore = useRequisiteStore();
  const {
    data: requisites
  } = storeToRefs(requisiteStore);
  const loadingItemId = ref(null) as Ref<string | null>;
  onMounted(async () => {
    if (!requisites.value?.items) {
      await requisiteStore.GET_REQUISITES();
      const {
        requisite,
        ...query
      } = router.currentRoute.query;
      if (requisite) {
        const _requisit = requisites.value.items?.find((item: Requisite) => item.purse === requisite);
        if (_requisit && _requisit.status === "APPROVED" && !_requisit.isDisabled) {
          input.value.requisiteId = _requisit.id;
          input.value.amount = _requisit.paymentSystem.minimalPayout;
        } else {
          ToastProgrammatic.open({
            duration: 5000,
            message: i18n.t(`common.cardsRedirect.${_requisit ? "requisiteNotAvailable" : "requisiteMissing"}`),
            type: "is-danger"
          } as BNoticeConfig);
        }
        router.replace({
          query
        });
      }
    }
  });
  const isLoading = useWait(payoutStore, "ORDER_PAYMENT");
  const selectedRequisite = computed(() => {
    return requisites.value.items?.find((item: Requisite) => item.id === input.value.requisiteId) || {};
  });
  const balanceFloat = computed(() => {
    const findValueCurrency = storeInstance.state.balance.balance?.find((el: Money) => el.currency === selectedRequisite.value.paymentSystem?.currency)?.value ?? 0;
    return parseFloat(toFixed(findValueCurrency, 2) ?? "");
  });
  const sortedRequisites = computed(() => {
    return requisites.value?.items?.slice().sort((a: Requisite, b: Requisite) => {
      const getPriority = (item: Requisite) => {
        if ([RequisiteStatusEnum.CREATED, RequisiteStatusEnum.WAITING_FOR_APPROVE].includes(item.status)) return 0;
        if (item.status === RequisiteStatusEnum.DENIED) return 2;
        if (item.paymentSystem.isDisabled) return 3;
        return 1;
      };
      return getPriority(a) - getPriority(b);
    });
  });
  const hasLMCard = computed(() => {
    return requisites.value?.items?.some((item: Requisite) => item.paymentSystem.integrator.alias === "lm_cards");
  });
  const translationKey = "webmaster.finances.financeOrder.messages";
  const validationAmount = computed(() => {
    if (!input.value.amount) {
      return i18nPlugin.t(translationKey + ".errorEmpty");
    } else if (input.value.amount < selectedRequisite.value.paymentSystem?.minimalPayout) {
      return i18nPlugin.t(translationKey + ".errorMinAmount", {
        value: formatCurrency(selectedRequisite.value.paymentSystem?.minimalPayout, selectedRequisite.value.paymentSystem?.currency)
      });
    } else if (input.value.amount > balanceFloat.value) {
      return i18nPlugin.t(translationKey + ".errorMaxAmount", {
        value: formatCurrency(balanceFloat.value, selectedRequisite.value.paymentSystem?.currency)
      });
    }
    return "";
  });
  function removeRequisite(id: string) {
    DialogProgrammatic.confirm({
      title: i18nPlugin.t("webmaster.finances.paymentModal.payment.deleteConfirm.title") as string,
      message: i18nPlugin.t("webmaster.finances.paymentModal.payment.deleteConfirm.message") as string,
      confirmText: i18nPlugin.t("common.buttons.delete") as string,
      cancelText: i18nPlugin.t("common.buttons.cancel") as string,
      type: "is-danger is-light",
      onConfirm: async () => {
        try {
          loadingItemId.value = id;
          await actionWithToast(requisiteStore.REMOVE_REQUISITE(id), "webmaster.finances.paymentModal.payment.messages.deleteRequisite");
        } finally {
          loadingItemId.value = null;
        }
      }
    });
  }
  async function submit() {
    await actionWithToast(payoutStore.ORDER_PAYMENT(), "webmaster.finances.paymentModal.payment.messages.orderPayment");
    storeInstance.dispatch("GET_WEBMASTER_BALANCE");
  }
  onUnmounted(() => {
    input.value.requisiteId = null;
  });
  return Object.assign({
    RequisiteStatusEnum,
    input,
    loadingItemId,
    isLoading,
    selectedRequisite,
    balanceFloat,
    sortedRequisites,
    hasLMCard,
    validationAmount,
    removeRequisite
  }, {
    submit
  });
};
__sfc_main.components = Object.assign({
  FinancePaymentList,
  CanCopy
}, __sfc_main.components);
export default __sfc_main;
